<template>
  <div class="exchange-rates">
    <div class="exchange-rates__title">{{ $res.Views.ExchangeRatesArchive_EnterDateInFormat }}</div>
    <div class="rates-form">
      <div class="rates-form__date-container">
        <date-picker 
          size="max" 
          v-model="date" 
          @change="date = $event" 
          :locale="$res.CurrentCulture"
          :is-disabled-day-fn="isDisabledDay"
          style="width: 100%"
        />
      </div>
      <base-button 
        type="submit"
        theme="primary"
        size="max"
        variant="default"
        class="rates-form__submit"
        :disabled="!canSubmit"
        @click="onSubmit"
      >
        {{ $res.Views.CmsNewsItem_ToSearch }}
      </base-button>
    </div>
    <div v-if="hasResults || rateNotFound" class="rates-panel">
        <div class="rates-panel__title">{{ $res.Views.ExchangeRatesArchive_RatesOnDate }} {{ $formatDayWithFullMonth(requestDate)}}</div>
        <div v-if="hasResults" class="rates-panel__rates">
          <div v-for="(r, ix) in rates" :key="ix" class="rates-panel__rate">
            <span>{{r.SourceCurrency}}</span>&nbsp;
            <span>{{formatRate(r.Rate)}}</span>
          </div>
        </div>
        <div v-if="rateNotFound" class="rates-panel__rate">{{ $res.General.NoExchangeRatesFound }}</div>
    </div>
  </div>
</template>

<script>
import BaseButton from "@/common/controls/BaseButton.vue";
import DatePicker from "@/common/controls/forms/date-picker/DatePicker.vue";
import { isEmpty } from "lodash";
import { post } from "@/common/fetch";

export default {
  components: {
    DatePicker,
    BaseButton
  },
  data() {
    let currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);

    return {
      date: currentDate,
      rates: [],
      locale: null,
      maxDate: currentDate,
      requestDate: null,
      rateNotFound: false
    }
  },
  computed: {
    hasResults: function () {
      return !isEmpty(this.rates);
    },
    canSubmit: function () {
      return !!this.date;
    }
  },
  mounted: function () {
    this.locale = this.$res.CurrentCulture;
  },
  methods: {
    isDisabledDay: function(d) {
      return d > this.maxDate;
    },
    onSubmit: function () {
      this.requestDate = this.date;
      
      this.fetchData("/ExchangeRates/GetExchangeRates", {
          date: this.createDateParam(this.date)
      }).then(response => {
          this.rates = response.Rates;
          this.rateNotFound = response.RateNotFound;
      }).catch(error => {
          console.log(error);
      });
    },
    createDateParam: function (date) {
      const pad = (n) => n.toString().padStart(2, "0");
      
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
    },
    formatRate: function (value) {
      return new Intl.NumberFormat(
          this.locale,
          {minimumFractionDigits: 2, maximumFractionDigits: 4}
      ).format(value);
    },
    fetchData(url, parameters) {
      return new Promise((resolve, reject) => {
        post(url, parameters, true).then((serviceResult) => {
          resolve(serviceResult);
        }).catch((e) => {
          console.log(e);
          reject(Resources.Errors.General_SomethingWentWrong)
        });
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.exchange-rates {
  padding: 40px 24px;
  box-shadow: var(--shadow);
  border-radius: var(--border-radius-lg);
  background-color: var(--white);
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.exchange-rates__title {
  font-size: 18px;
  line-height: 28px;
  font-weight: 600;
}

.rates-form,
.rates-panel,
.exchange-rates__title {
  width: 424px;
}

.rates-form {
  display: flex;
  align-items: center;
  gap: 24px;
}

.rates-panel {
  background-color: var(--main-50);
  padding: 20px 24px;
  border-color: var(--border-radius-lg);
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-radius: var(--border-radius-lg);
}

.rates-panel__title {
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
}

.rates-panel__rate {
  flex-grow: 1;
  font-size: 16px;
  line-height: 24px;
  
  span:last-child {
    margin-left: -4px;
  }
}

.rates-panel__rates {
  display: flex;
  width: 100%;
  gap: 16px;
}

.button.rates-form__submit {
  width: 104px;
  min-width: 104px;
  max-width: 104px;
}

.rates-form__date-container {
  flex-grow: 1;
}
</style>
